import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export const urlImgAsig = {
    url: 'https://firebasestorage.googleapis.com/v0/b/trabajogrado-77f48.appspot.com/o/Image%20Default%2FdefaultAsignatura.png?alt=media&token=60614ef9-937a-466b-88f7-6dc518d73241'
}


export const SECCCION_UNO = 'Seccion1';
export const SECCCION_DOS = 'Seccion2';
export const SECCCION_TRES = 'Seccion3';
export const SECCCION_CUATRO = 'Seccion4';
export const SECCCION_CINCO = 'Seccion5';


export const alertDeleteQuestion = {
    title: "Estas seguro de eliminar?",
    text: "Una vez eliminada la pregunta no podras recuperarla!",
    icon: "warning",
    buttons: true,
    dangerMode: true,
}

export const deleteQuestion = "Poof! Tu Pregunta ha sido eliminada"

export const dontDeleteQuestion = "Tranquil@! la pregunta no se ha borrado"

export const collection = 'Aula'
export const collection2 = 'Subjects'
export const temascollection = 'topics'
export const commentscollection = 'comments'



export const columns = [
    {
        name: 'Foto',
        selector: row => <figure className='tb-progress'><img src={row.photoUrl} alt='imagen' /></figure>
        ,
    },
    {
        name: 'Email',
        selector: row => row.id,
        grow: 2
    },
    {
        name: 'Nombre Estudiante',
        selector: row => row.nameUser,        
        grow: 2
    },
    {
        name: 'Ultimo Progreso',
        selector: row => moment(row.date).fromNow()
    },
    {//row.progress
        name: 'Progreso',
        selector: row => <div className='tb-progres'><label>{(row.progress/row.cantThemes)*100} %</label><progress max="100" value={(row.progress/row.cantThemes)*100}></progress></div>,
    }
];


export const paginationOptions = {
    rowsPerPageText: 'Filas por pagina',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'todos'
}


export const backgroundColor = [
    'rgba(255, 99, 132, 0.2)',
    'rgba(54, 162, 235, 0.2)',
    'rgba(255, 206, 86, 0.2)',
    'rgba(75, 192, 192, 0.2)',
    'rgba(153, 102, 255, 0.2)',
    'rgba(255, 159, 64, 0.2)',
];
export const borderColor = [
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 159, 64, 1)'
];
